<template>
  <div class="py-2" ref="inputbox">
    <!-- image upload -->
    <div class="sr-uploader">
      <draggable
        :list     = "imageGroups"
        :disabled = "disable"
        handle    = ".sr__drag-handle"
        @end      = "sortImageGroups"
      >
        <div
          class = "sr-uploader__imgs-area"
          v-for = "(imageGroup, idx) in imageGroups"
          :key  = "imageGroup.id"
        >
          <!-- drag icon -->
          <div
            v-if  = "!disable"
            class = "sr-uploader__x sr__drag-handle"
            style = "left: 5px; right: auto; cursor: move;"
          >
            <b-icon icon="list"></b-icon>
          </div>

          <!-- delete icon  -->
          <div
            class  = "sr-uploader__x"
            @click = "deleteImageGroup(idx)"
            v-if   = "!disable"
          >
            <b-icon icon="x"></b-icon>
          </div>

          <!-- images -->
          <div class="w-100 d-flex justify-content-between">
            <div
              class  = "sr-uploader__img"
              @click = "showLightbox(imageObj)"
              v-for  = "(imageObj, objIdx) in imageGroup.images"
              :key   = "`imageObj-${objIdx}`"
            >
              <img v-if="imageObj?.url" :src="getImageUrl(imageObj)">
              <img v-else src="../../assets/no_image.jpeg" style="border: 1px solid #c9c9c9; object-fit: contain;">
            </div>
          </div>

          <!-- images desc -->
          <div class="w-100 d-flex justify-content-between">
            <div class="sr-uploader__img-desc-box">
              <div class="sr-uploader__img-desc">前照</div>
            </div>

            <div
              v-if   = "!disable"
              class  = "sr-uploader__img-desc-box"
              @click = "switchImages(imageGroup)"
            >
              <b-icon icon="arrow-left-right"></b-icon>
            </div>

            <div class="sr-uploader__img-desc-box">
              <div class="sr-uploader__img-desc">後照</div>
            </div>
          </div>
        </div>
      </draggable>

      <!-- uploader -->
      <div
        class  = "sr-uploader__area"
        @click = "openFileInput"
        v-if   = "!disable"
      >
        <img src="../../assets/img/upload.png">
        <div class="sr-uploader__desc">
          {{ `上傳前後照${imageUploading ? '中...' : ''}` }}
        </div>
        <input
          type      = "file"
          ref       = "file"
          style     = "display: none"
          multiple  = "multiple"
          @change   = "uploadImages"
          :disabled = "imageUploading"
        />
      </div>

      <!-- lightbox -->
      <div
        class  = "lightbox"
        :class = "{'lightbox--active': lightboxActive}"
        @click = "lightboxActive=false"
      >
        <div class="lightbox-image-box" :style="{'top': lightboxImgTop}">
          <img ref="lightboxImage" :src="lightboxImgSrc">
        </div>
      </div>
    </div>

    <!-- invalid msg -->
    <b-form-invalid-feedback :state="valid">
      {{invalidMsg}}
    </b-form-invalid-feedback>
  </div>
</template>

<script>
import draggable from 'vuedraggable'

export default {
  name: 'ImageGroupItem',
  props: {
    field: Object,
    disable: Boolean
  },
  data () {
    return {
      serviceType: '',
      recordId: '',
      imageGroups: [],
      lightboxImgSrc: '',
      lightboxImgTop: '0',
      lightboxActive: false,
      imageUploading: false,
      switching: false,
      toValidate: true,
      valid: true,
      invalidMsg: ''
    }
  },
  methods: {
    apiUrl (action) {
      return `${this.$apiDoc.staffUrlV1}/${this.$store.state.userId}/${this.$apiDoc.apiGetService}/${this.recordId}/${action}`
    },
    showLightbox (imageObj) {
      if (!imageObj?.url) {
        return
      }

      this.lightboxImgTop = `${window.scrollY}px`
      this.lightboxImgSrc = this.getImageUrl(imageObj)
      this.lightboxActive = true
    },
    openFileInput () {
      this.$refs.file.click()
    },
    async switchImages (imageGroup) {
      if (this.switching) {
        return
      }

      this.switching = true
      try {
        await this.$api.post(this.apiUrl('switch_image_group'), { image_group_id: imageGroup.id })
        var front = imageGroup.images[0]
        var back = imageGroup.images[1]
        imageGroup.images = [back, front]
      } catch (error) {
        alert(error)
      }
      this.switching = false
    },
    getImageUrl (imageObj) {
      return `${this.$apiDoc.uploadedImageDomain}/${imageObj.url}`
    },
    async getImageGroups () {
      var resp = await this.$api.get(this.apiUrl('get_image_groups'), { service_type: this.serviceType })
      this.imageGroups = resp.image_groups
    },
    async deleteImageGroup (index) {
      var yes = confirm('確定刪除?')
      if (yes) {
        var imageGroup = this.imageGroups[index]
        await this.$api.get(this.apiUrl('destroy_image_group'), { image_group_id: imageGroup.id })
        this.imageGroups.splice(index, 1)
      }
    },
    async sortImageGroups (event) {
      await this.$api.post(
        this.apiUrl('sort_image_groups'),
        {
          service_type: this.serviceType,
          image_group_ids: this.imageGroups.map(group => group.id)
        }
      )
    },
    compressImage (file) {
      if (!file) {
        return Promise.resolve(null)
      }

      var qty = 0.7
      var qty2m = 2 * 1024 * 1024
      var qty3m = 3 * 1024 * 1024
      var qty4m = 4 * 1024 * 1024
      if (file.size > qty2m) {
        qty = 0.6
      }

      if (file.size > qty3m) {
        qty = 0.3
      }

      if (file.size > qty4m) {
        qty = 0.2
      }

      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)

        reader.onload = (event) => {
          const img = new Image()
          img.src = event.target.result
          img.onload = () => {
            var canvas = document.createElement('canvas')
            var ctx = canvas.getContext('2d')
            canvas.width = img.width
            canvas.height = img.height
            ctx.drawImage(img, 0, 0)

            // 壓縮並轉換為 JPEG 格式
            canvas.toBlob(
              (blob) => {
                var fileName = file.name.replace(/\.[^/.]+$/, '')
                resolve(new File([blob], fileName))
              },
              'image/jpeg',
              qty
            )
          }
        }
      })
    },
    async uploadImages () {
      var files = Array.from(this.$refs.file.files)

      if (files.length < 1) {
        alert('請上傳至少一張圖片')
        this.$refs.file.value = ''
        return
      }

      try {
        var compressFiles = await Promise.all([this.compressImage(files[0]), this.compressImage(files[1])])
        this.imageUploading = true
        const group = await this.createImageGroup(compressFiles)
        if (group !== null) {
          this.imageGroups.push(group)
        }
      } catch (e) {
        console.log(`壓縮圖片失敗: ${e}`)

        // upload original uploaded files
        const group = await this.createImageGroup(files)
        if (group !== null) {
          this.imageGroups.push(group)
        }
      }

      this.$refs.file.value = ''
      this.imageUploading = false
      this.checkValueIsValid()
    },
    async createImageGroup (files) {
      try {
        var formData = new FormData()
        formData.append('before_img', files[0])
        formData.append('after_img', files[1])
        formData.append('service_type', this.serviceType)

        const resp = await this.$api.post(this.apiUrl('create_image_group'), formData, { headers: { 'Content-Type': 'multipart/form-data' } })

        return resp.image_group
      } catch (e) {
        console.log(e)
        alert('上傳圖片失敗, 請連絡工程師')
        return null
      }
    },
    checkValueIsValid (uiNotify = true) {
      if (!this.toValidate) {
        this.valid = true
        this.invalidMsg = ''
        return true
      }

      if (this._isDestroyed) {
        this.valid = true
        this.invalidMsg = ''
        return true
      }

      if (this.imageGroups.length < 1) {
        if (!uiNotify) {
          return false
        }

        this.valid = false
        this.invalidMsg = '需上傳圖片'
      } else {
        this.valid = true
        this.invalidMsg = ''
      }

      return this.valid
    }
  },
  async created () {
    this.recordId = this.$route.params.id
    this.serviceType = this.field.config.service_type || this.serviceType

    await this.getImageGroups()
  },
  mounted () {
    var top = this.$refs.inputbox.getBoundingClientRect().top

    if (this.toValidate) {
      this.$store.dispatch('pushValidateInfo', {
        id: this._uid,
        top: () => { return top },
        checkValueIsValid: this.checkValueIsValid
      })
    }
  },
  components: {
    draggable
  }
}
</script>
